function isObject(value) {
  const type = typeof value
  return value != null && (type == 'object' || type == 'function')
}

export default class OAuthUserService {
  constructor($http, $state, tokenService, oauthConfig) {
    "ngInject";
    this.http = $http;
    this.$state = $state;
    this.tokenService = tokenService;
    this.config = oauthConfig;
    this.user = null;
  }
  fetchUsers(params) {
    const url = `${this.config.authentificationApi}/user`
    return this.http.get(url, {params})
    .then(res => res.data)
  }
  getTokenData(token) {
    let data = token.split('.')
    data = data[1]
    data = atob(data)
    data = JSON.parse(data)
    
    if (this.tokenService.getDecodedUsername()) {
      data.user_show_name = this.tokenService.getDecodedUsername()
    }
    
    return data;
  }
  tokenDataIsValid(tokenData) {
    const expirationDate = tokenData.exp * 1000;
    const now = Date.now();
    return expirationDate > now;
  }
  login() {
    const token = this.tokenService.getToken()
    if(token) {
      // nuevo flujo de login
      // 1. descodificar token
      // 2. guardar datos descodificados como datos de usuario
      // 3. comprobar si el token esta caducado
      //   3.1 si esta ok, this.redirectUserByRole()
      //   3.2 si esta caducado, llevar a tokenService.getLoginEndpoint()

      this.user = this.getTokenData(token);
      if(this.tokenDataIsValid(this.user)) {
        let redirect = sessionStorage.getItem('opk_oauth_temp_redirect')
        if(redirect) {
          redirect = JSON.parse(redirect)
          sessionStorage.removeItem('opk_oauth_temp_redirect')
          this.$state.go(redirect.nextState, redirect.nextParams)
        } else {
          this.redirectUserByRole();
        }
      } else {
        console.log("OauthUserService: token caducado. pidiendo de nuevo")
        this.tokenService.setToken(null)
        window.location.href = this.tokenService.getLoginEndpoint()
      }
    } else {
      window.location.href = this.tokenService.getLoginEndpoint()
    }
  }
  logout() {
    this.user = null
    this.tokenService.setToken(null)
    window.location.href = this.tokenService.getLogoutEndpoint()
  }
  redirectUserByRole() {
    const roleKeys = Object.keys(this.config.user_roles)
    const selectedKeys = roleKeys.filter(key => {
      const role = this.config.user_roles[key]
      return this.userHasRole(role)
    })
    this.goToRole(selectedKeys[0])
  }
  goToRole(role_key) {
    const badlogin = this.config.no_role_redirect
    const state = role_key ? this.config.user_redirects[role_key] : badlogin
    if(isObject(state)) {
      this.$state.go(state.name, state.params)
    } else {
      this.$state.go(state)
    }
  }
  userIsLogged() {
    return !!this.user
  }
  userHasRole(role) {
    // caso de uso especial
    if(role === "ANY") {
      return this.userIsLogged();
    }
    if(Array.isArray(role)) {
      return role.some(role => this.getUserRoles().indexOf(role) !== -1)
    }
    return this.getUserRoles().indexOf(role) !== -1
  }
  getUserRoles() {
    return this.userIsLogged() ? this.user.authorities : []
  }
  getUserId() {
    return this.userIsLogged() ? this.user.uuid : null
  }
  getUserName() {
    return this.userIsLogged() ? this.user.user_show_name : null
  }
}


// WEBPACK FOOTER //
// ./src/services/oauthUser.service.js